import React from "react";
import { Icon } from "@iconify/react";

const FeedIcon = () => (
  <Icon icon="lucide:newspaper" width={18} height={18} />
);

export default FeedIcon;
